__turbopack_context__.v({
  "blogCard": "_-module__F1lUfW__blogCard",
  "categorySuggestionsContainer": "_-module__F1lUfW__categorySuggestionsContainer",
  "container": "_-module__F1lUfW__container",
  "icon": "_-module__F1lUfW__icon",
  "input": "_-module__F1lUfW__input",
  "suggestion": "_-module__F1lUfW__suggestion",
  "suggestionHighlighted": "_-module__F1lUfW__suggestionHighlighted",
  "suggestionsContainer": "_-module__F1lUfW__suggestionsContainer",
});
